module.exports = __webpack_public_path__ + "img/logo.296337f2.png";